export default "__VITE_ASSET__D3e3bRRF__"